import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as tasksActions from '../actions/tasksActions';
import { connect } from 'react-redux';
import TaskState from '../../../../shared/model/TaskState';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import DateFormatter from '../../../../shared/utils/DateFormatter';

class TaskTableRow extends React.Component {

    render() {

        const {task} = this.props;

        if ( !task ) {
            return null;
        }

        const views = [];

        views.push(
            <tr className={task.id === this.props.active ? 'subtask-bg-active' : this.props.rowsClassName}
                key={task.id}>
                <td align="right">
                    <div className="form-check validate-check">
                        <input
                            type="checkbox"
                            id={`check-task-${task.id}`}
                            className="filled-in chk-col-blue-grey"
                            checked={task.task_state.id === TaskState.VALIDATED}
                            onChange={(value) => {
                                this.props.tasksActions.changeTaskState(task, value.target.checked === true ? TaskState.VALIDATED : TaskState.PENDING);
                            }}
                        />
                        <label htmlFor={`check-task-${task.id}`}></label>
                    </div>
                </td>
                <td>{this.renderDate(task)}</td>
                <td>{task.construction && task.construction.code ? task.construction.code : ''}</td>
                <td><strong>{task.company_child ? task.company_child.name : ''}</strong></td>
                {this.renderTdState(task.document_data.monthly, () => this.props.tasksActions.getDocumentsMonthly(task))}
                {this.renderTdState(task.document_data.linked, () => this.props.tasksActions.getDocumentsLinked(task))}
                {this.renderTdState(task.document_data.worker, () => this.props.tasksActions.getWorkChecks(task))}
                {this.renderTdState(task.document_data.company, () => this.props.tasksActions.getDocumentsCompany(task))}
                {this.renderTdSendEmail(task)}
            </tr>
        );

        if ( task.children ) {
            task.children.forEach((children) => {
                views.push(
                    <tr className={children.id === this.props.active ? 'subtask-bg-active' : this.props.rowsClassName}
                        key={children.id}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="sub"><i
                            className="material-icons">subdirectory_arrow_right</i><strong>{children.company_child ? children.company_child.name : ''}</strong>
                        </td>
                        {this.renderTdState(children.document_data.monthly, () => this.props.tasksActions.getDocumentsMonthly(children))}
                        {this.renderTdState(children.document_data.linked, () => this.props.tasksActions.getDocumentsLinked(children))}
                        {this.renderTdState(children.document_data.worker, () => this.props.tasksActions.getWorkChecks(children))}
                        {this.renderTdState(children.document_data.company, () => this.props.tasksActions.getDocumentsCompany(children))}
                        {this.renderTdSendEmail(children)}
                    </tr>
                );

                if ( children.children ) {
                    children.children.forEach((subChildren) => {
                        views.push(
                            <tr className={subChildren.id === this.props.active ? 'subtask-bg-active' : this.props.rowsClassName}
                                key={subChildren.id}>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="sub sub2"><i
                                    className="material-icons">subdirectory_arrow_right</i><strong>{subChildren.company_child ? subChildren.company_child.name : ''}</strong>
                                </td>
                                {this.renderTdState(subChildren.document_data.monthly, () => this.props.tasksActions.getDocumentsMonthly(subChildren))}
                                {this.renderTdState(subChildren.document_data.linked, () => this.props.tasksActions.getDocumentsLinked(subChildren))}
                                {this.renderTdState(subChildren.document_data.worker, () => this.props.tasksActions.getWorkChecks(subChildren))}
                                {this.renderTdState(subChildren.document_data.company, () => this.props.tasksActions.getDocumentsCompany(subChildren))}
                                {this.renderTdSendEmail(subChildren)}
                            </tr>
                        );
                    });
                }

            });
        }

        return ( views );
    }

    renderDate(task) {
        if ( !task || !task.month || !task.year ) {
            return null;
        }
        return task.month + '/' + task.year;
    }

    renderTdState(data, action = () => {
    }) {
        return (
            <td className="text-center">
                <button type="button" className="btn-none" onClick={action}>
                    {this.renderIcon(data)}
                    <span className={'hide'}>V: {data.validated} P: {data.pending} PV: {data.pending_validation}</span>
                </button>
            </td>
        );
    }

    renderTdSendEmail(task) {
        if ( task.email_sent_date ) {
            return (
                <td className="text-right">
                    <strong>{DateFormatter.formatDate(task.email_sent_date)}</strong>
                </td>
            );
        }
        return (
            <td className="text-right">
                <button type="button" className="btn bg-blue-grey waves-effect"
                        onClick={() => this.props.tasksActions.sendMailTask(task)}>{I18nUtils.tr('TR_ENVIAR')}</button>
            </td>
        );
    }

    /**
     * - Si hay documentos pendientes de validación => es trabajo del contratista (naranja).
     * - Si no hay pendientes de validación pero sí hay pendientes => es trabajo de la subcontrata (lupa).
     * - Si no hay ni pendientes de validación ni pendientes (validado) => está hecho (verde).
     *
     *  NOTA: El semáforo naranja manda sobre la lupa.
     *  NOTA: Aunque no hayan documentos validados en el tercer caso (no existen documentos), se muestra verde.
     *  NOTA: Dentro de los pendientes entran: pendientes, caducados y rechazados.
     */
    renderIcon(data) {
        const displayPendingValidation = data.pending_validation > 0;
        const displayPending = data.pending_validation === 0 && data.pending > 0;
        const displayValidated = data.pending_validation === 0 && data.pending === 0;

        if ( displayPendingValidation ) return <span className="pendiente-validar"/>;
        if ( displayPending ) return <i className="material-icons">find_in_page</i>;
        if ( displayValidated ) return <span className="up-to-date"/>;
        return null;
    }

}

const mapDispatchToProps = dispatch => ( {
    tasksActions: bindActionCreators(tasksActions, dispatch),
} );

export default connect(null, mapDispatchToProps)(TaskTableRow);

TaskTableRow.propTypes = {
    task: PropTypes.objectOf(PropTypes.any).isRequired,
    rowsClassName: PropTypes.string.isRequired,
    active: PropTypes.number,
};

TaskTableRow.defaultProps = {
    rowsClassName: '',
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/components/TaskTableRow.js